<template>
  <div class="mask" v-if="show">
    <!-- <div class="exit" @click="show = false;localSet('EDIT_ORDER_NEXT_GUIDE',1);localSet('EDIT_ORDER_KOWN_GUIDE',1);">退出引导</div> -->
    <!-- 订单中心 -->
    <div class="home-guide" v-if="routeName === 'home_index' && showfee1">
      <img src="../images/fee-confirm-guide-1.png" />
      <div class="transparent-btn home-guide-btn" @click="handleClose" :style="btnPosition">
        我知道了
      </div>
    </div>
    <div class="quit-guide" v-if="routeName === 'home_index' && showUserLead">
      <img src="../images/quit-mask1.png" />
      <div class="transparent-btn home-guide-btn1" @click="goPersonal">
        查看企业信息
      </div>
    </div>
    <!-- <div class="quit-guide" v-if="routeName === 'home_index' && !localGet('EDIT_ORDER_NEXT_GUIDE')" style="left: 120px; top: 220px; width: 500px; ">
      <img style="height: auto" src="../images/edit_order_next.png" />
      <div class="transparent-btn" style="position: absolute; left: 100px; top: 130px;" @click="localSet('EDIT_ORDER_NEXT_GUIDE',1);$router.push({ path:'order-booking/index' });">
        下一步
      </div>
    </div>
    <div class="quit-guide" v-if="routeName === 'order-booking_index' && !localGet('EDIT_ORDER_KOWN_GUIDE')" style="left: 200px; top: 260px; width: 500px;">
      <img style="height: auto" src="../images/edit_order_kown.png" />
      <div class="transparent-btn" style="position: absolute; left: 100px; top: 130px;" @click="()=>{localSet('EDIT_ORDER_NEXT_GUIDE',1);localSet('EDIT_ORDER_KOWN_GUIDE',1);handleClose()}">
        我知道了
      </div>
    </div> -->
    <template v-if="routeName === 'fee-confirmation_index' && showfee1">
      <img src="../images/fee-bg.png" class="fee-bg" />
      <div class="fee-mask"></div>
    </template>
    <div class="fee-guide" v-if="routeName === 'fee-confirmation_index'">
      <img src="../images/fee-confirm-guide-2.png" />
      <div class="transparent-btn fee-guide-btn" @click="handleClose">
        我知道了
      </div>
    </div>
    <div
        class="quit-guide1"
        v-if="routeName === 'personal-center' && showUserLead"
        :style="innerHeight < 900 ? 'top:66%;right:7%' : 'top:51%;right:12%'"
      >
      <img
        src="../images/quit-mask2.png"
        :style="innerHeight < 900 ? 'width:250px' : 'width:300px'"
      />
      <div class="transparent-btn fee-guide-btn1" @click="close">我知道了</div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import dayjs from "dayjs";
import { login } from '@/router';
// 费用确认 新功能上线引导框
const CACHE_KEY = "FEE_CONFIRM_GUIDE_COUNT";
import { showUserLeadStatus, clickLead } from '@/api/home';
import { userInfo } from '@/api/certification'
export default {
  data() {
    return {
      show: false,
      showfee1:true,
      showUserLead: false,
      innerHeight: window.innerHeight,
    };
  },
  methods: {
    goPersonal() {
      this.$router.push({ path: "personal-center" });
    },
    close() {
      clickLead().then((res) => {
        this.show = false;
      });
    },
    handleClose() {
      this.showfee1 = false
      this.show = false
      // 引导计数
      this.count(this.routeName);
    },
    /**
     * @desc 记录弹窗
     */
    count(key) {
      let obj = JSON.parse(localStorage.getItem(CACHE_KEY) || `{}`);
      if (!obj[key]) {
        obj[key] = 0;
      }
      obj[key]++;
      localStorage.setItem(CACHE_KEY, JSON.stringify(obj));
    },
    getCount(key) {
      let obj = JSON.parse(localStorage.getItem(CACHE_KEY) || `{}`);
      return obj[key] || 0;
    },
    userInfo(){
      userInfo().then(res => {
        if(res && res.data.success) {
          let data = res.data.data
          if(data.userStatus === 'DONE'){
            this.getMask()
          }else if(this.routeName === 'personal-center'){
            this.show = false
          }
        }
      })
    },
    // 退出企业引导
    getMask(){
      showUserLeadStatus().then( res => {
        if(res && res.data.success){
          if(res.data.data.value == 'true'){
            // 不显示
            this.showUserLead = false
          }else {
            if (["home_index", "fee-confirmation_index", 'personal-center'].includes(this.$route.name)) {
              this.show = true
              this.showUserLead = true
              this.$store.commit("user/userLeadStatus", true)
            }
          }
        }
      })
    },
    // localGet(item) {
    //   return localStorage.getItem(item)
    // },
    // localSet(item,value) {
    //   localStorage.setItem(item,value)
    // }
  },
  watch: {
    $route() {
      const routeName = this.$route.name;
      if(Cookies.get('user')){
        this.userInfo()
      }
      // 没有拿到登录记录,
      // 记录一个
      const defaultReord = {
        ts: Date.now(),
        userId: Cookies.get("userId"),
      };
      const recordString = localStorage.getItem("FEE_GUIDE_LOGIN_RECORD");
      let loginRecord
      if (!recordString) {
        loginRecord = defaultReord
        localStorage.setItem("FEE_GUIDE_LOGIN_RECORD", JSON.stringify(defaultReord))
        localStorage.setItem("FEE_CONFIRM_GUIDE_COUNT", '')
      } else {
        loginRecord = JSON.parse(recordString)
      }
      if (["home_index", "fee-confirmation_index", 'personal-center'].includes(routeName)) {
        const hasShow = this.getCount(routeName)
        // 没有开过, 小于三天, 则展示
        if (!hasShow && Date.now() - loginRecord.ts <= 3 * 24 * 60 * 60 * 1000) {
          this.showfee1 = true
        } else {
          this.showfee1 = false;
        }
      } else {
        this.show = false;
      }
      // if (["home_index","order-booking_index", ].includes(routeName) && (!this.localGet('EDIT_ORDER_NEXT_GUIDE') || !this.localGet('EDIT_ORDER_KOWN_GUIDE'))) {
      //   this.show = true; 
      // }else{
      //   this.show = false;
      // }
    },
  },
  computed: {
    routeName() {
      return this.$route.name;
    },
    btnPosition() {
      if (window.innerHeight < 700) {
        return {
          bottom: '120px'
        }
      } else if(window.innerHeight < 780) {
        return {
          bottom: "-30px"
        }
      } else {
        return {}
      }
    }
  },
};
</script>

<style lang="less" scoped>
.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 990;
  .exit{
    position: absolute; 
    right: 200px; 
    top: 80px; 
    color: #fff; 
    border:1px solid #fff;  
    width: 100px; 
    height: 50px; 
    border-radius: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
  .transparent-btn {
    display: inline-block;
    color: #fff;
    border: 1px solid #fff;
    padding: 4px 8px;
    cursor: pointer;
    font-size: 13px;
  }
  .home-guide-btn {
    bottom: -80px;
    position: absolute;
    left: 46%;
    font-weight: bold;
  }
   .home-guide-btn1 {
    bottom: 26px;
    position: absolute;
    left: 38%;
    font-weight: bold;
  }
  .home-guide {
    position: fixed;
    left: 120px;
    top: 565px;
    img {
      height: 110px;
    }
  }
  .quit-guide {
    position: fixed;
    right: 45px;
    top: 45px;
    img {
      height: 270px;
    }
  }
  .fee-mask {
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    left: 0;
  }
  .fee-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    &::after {
      display: block;
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      z-index: 10000000;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
    }
  }
  .fee-guide {
    position: fixed;
    left: ~"calc(12.7% - 98px)";
    top: 28%;
    img {
      // height: 155px;
      width: 1000px;
    }
    .fee-guide-btn {
      margin-top: 100px;
      position: absolute;
      left: 46%;
      font-weight: bold;
    }
  }
  .quit-guide1 {
    position: fixed;
    top: 51%;
    right: 12%;
    img {
      width: 300px;
    }
    .fee-guide-btn1 {
      position: absolute;
      left: 36%;
      bottom: 20px;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// fee-confirm-guide.vue?4bed6cc9